export class PngImageBuilder {
    private canvas: HTMLCanvasElement;
    private context: CanvasRenderingContext2D | null;

    constructor(width: number, height: number) {
        this.canvas = document.createElement('canvas');
        this.canvas.width = width;
        this.canvas.height = height;
        this.context = this.canvas.getContext('2d');
        if (this.context) {
            this.context.fillStyle = 'white';
            this.context.fillRect(0, 0, width, height);
            this.context.fillStyle = 'black';
            this.context.textAlign = 'center';
            this.context.textBaseline = 'top';
        }
    }

    getWidth(): number {
        return this.canvas.width;
    }

    getHeight(): number {
        return this.canvas.height;
    }

    writePixel(x: number, y: number, size: number): void {
        if (this.context) {
            this.context.fillRect(x, y, size, size);
        }
    }

    writeText(x: number, y: number, text: string, fontSize: number): void {
        if (this.context) {
            this.context.font = 'bold ' + fontSize + 'px Arial';
            this.context.fillText(text, x, y);
        }
    }

    toArray(): Uint8Array {
        let str: string = atob(this.canvas.toDataURL().split(',')[1]);
        let bin: Uint8Array = new Uint8Array(str.length);
        for (let i = 0; i < str.length; ++i) {
            bin[i] = str.charCodeAt(i);
        }
        return bin;
    }

    toString(): string {
        return this.canvas.toDataURL();
    }
}
